import Lazyload from 'react-lazy-load'
import { StartTrialModal } from '.'
const ContestandChallenges = (props) => {
    return (
        <>
         <section className="bannerAreaN greyBackgroundN BannerDeatils greyBackground position">
             <div className="detailsPageSection">
                <img src="https://res.cloudinary.com/vantagecircle/image/upload/w_1440,h_600/VantageFit/NewWebsite/pageBanner__compressed.png" alt="corporate wellness" className="img-responsive" width="1440" height="600"/>
             </div>
             <div className="BannerContent">
                 <div className="headingBannerM container customCampaignContainer text-left ">
                    <div className="row">
                        <div className=" col-lg-8 col-xs-12 col-md-7 col-sm-12"> 
                        <h1>Contest and Challenges</h1>
                        <p className="colorwhite w7">
                        Host a variety of wellness contests and challenges to encourage healthier lifestyles among your employees.
                        </p>
                        <div className="mtb25">
                            <a href="https://www.vantagefit.io/request-demo/" className="vfitwhitecta ">Schedule a Vantage Fit Demo</a>
                        </div>
                        </div>
                        <div className="col-lg-4  col-xs-12 col-md-5 col-sm-12 ">
                            <img alt="Step challenge" className ="mobileDisplay mobileimageW lozad" loading = "lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/Banner_Images_ContestsnChallenges.png" width="525" height="363"/>
                        </div>
                    </div>
                </div>
             </div>   
        </section>
        <section className="sectionSpacing greyBackgroundN pt-01 useCaseDesktop desktopView">
            <div className="container customCampaignContainer">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                        <div className="mainHeadingN text-center">Feature Glance</div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                        <p className=" text-center title_spc secondarytext">Here’s a quick look at some of the key features of Vantage Fit.</p>
                    </div>
                    <div className="row_elementor features title_spc featuresN" id="featuresN">
                        <div className="col-lg-5 col-md-6 col-xs-12 col-sm-12 left-activity">
                            <div data-img="activityN" className="box_item active-sec">
                                <div className="featuresimg">
                                    <div className="featuresSprite first-image activebox hidden-xs hidden-sm weeklystep"></div>
                                    <div className="featuresSprite second-image hidden-xs hidden-sm weeklystep"></div>
                                </div>
                                <div className="featurestext">
                                    <div className="trackertext">Weekly Step<br/> Challenges</div>
                                </div>
                                <div className="plusText featuresSprite activeBox"></div>
                                <div className="plusDisplayText onlineBox">Inspire your employees to keep moving with weekly step challenges and grab the top spot on the leaderboard.</div>
                            </div>
                            <div data-img="heartrateN" className="box_item">
                                <div className="featuresimg">
                                    <div className="featuresSprite first-image activebox hidden-xs hidden-sm distancebased"></div>
                                    <div className="featuresSprite second-image hidden-xs hidden-sm distancebased"></div>
                                </div>
                                <div className="featurestext">
                                    <div className="trackertext">Distance-Based <br/>Contests</div>
                                </div>
                                <div className="plusText featuresSprite activeBox"></div>
                                <div className="plusDisplayText onlineBox">Create exciting distance-based challenges and let your employees progress one mile at a time.</div>
                                
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-xs-12 col-sm-12 mid-activity hidden-xs hidden-sm">
                            <div id="activityN">
                                <img width="300" height="600" className="mob_image Image-Overlay active-img lozad" loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/Contests_Chllngs_Weekly_Step_Callenges.png" alt="Step challenge" />
                            </div>
                            <div id="heartrateN">
                                <img width="300" height="600" className="mob_image Image-Overlay lozad" loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/Distance_based_competition.png" alt="Walkathon" />
                            </div>
                            <div id="assessmentN">
                                <img width="300" height="600" className="mob_image Image-Overlay lozad" loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/walkathon.png" alt="workplace health campaign" />
                            </div>
                            <div id="meterN">
                                <img width="300" height="600" className="mob_image Image-Overlay lozad" loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/Contests_Chllngs_Health_Campaign.png" alt="Walkathon" />
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-6 col-xs-12 col-sm-12 right-activity">
                            <div data-img="assessmentN" className="box_item">
                                <div className="featuresimg">
                                    <div className="featuresSprite first-image activebox hidden-xs hidden-sm wlakathonS"></div>
                                    <div className="featuresSprite second-image hidden-xs hidden-sm wlakathonS"></div>
                                </div>
                                <div className="featurestext">
                                    <div className="moodmeter trackertext">Walkathon</div>
                                </div>
                                <div className="plusText featuresSprite activeBox"></div>
                                <div className="plusDisplayText onlineBox">Motivate employees to take a definite number of daily steps for mitigating the ill-effects of a sedentary lifestyle.</div>
                            </div>
                            <div data-img="meterN" className="box_item">
                                <div className="featuresimg">
                                    <div className="featuresSprite first-image activebox hidden-xs hidden-sm healthcampaignS"></div>
                                    <div className="featuresSprite second-image hidden-xs hidden-sm healthcampaignS"></div>
                                </div>
                                <div className="featurestext">
                                    <div className=" trackertext">Health<br/> Campaigns</div>
                                </div>
                                <div className="plusText featuresSprite activeBox"></div>
                                <div className="plusDisplayText onlineBox">Run automated health campaigns as per your desired timeline to streamline your organization's wellness initiatives seamlessly.</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12 cta_center">
                    <a className = "starttrailCTa">
                        <div><Lazyload><StartTrialModal /></Lazyload></div>
                    </a></div>
                </div>
            </div>
        </section>
       
        <section className = "sectionSpacing position usecasemobile mobileview contestchallngM" id="useCasez">
          <div className = "container customCampaignContainer">
            <div className = "row">
              <div className = "col-lg-12 col-md-12 col-xs-12 col-sm-12">
                <div className = "mainHeadingN ">
                  Features at a Glance
                </div>
                <div className = "subHeading">
                  Here’s a quick look at some of the key features of Vantage Fit.
                </div>
              </div>
            </div>
          </div>
           <div className="container customCampaignContainer " id = "useCasesz"> 
                <div className="row innerSpace">
                    <div className="col-lg-3 col-md-12 col-xs-12 col-sm-12 caseFilter active">
                      <div className="useCasesBoxes  weeklystep active featuresSpriteM"  attr = "walksteps"> Weekly Step Challenges</div>
                    </div>
                  </div>
                <div className="col-lg-12 usecaseDesc active" id = "walksteps">
                    <div className="onlineBox  row column-change  d-flex align_items_center  mt_25">
                        <div className="col-lg-7 col-md-7 col-xs-12 col-sm-12 ">
                            Inspire your employees to keep moving with weekly step challenges and grab the top spot on the leaderboard.
                        </div>
                        <div className="col-lg-5 col-md-5 col-xs-12 col-sm-12 ">
                            <img src = "https://res.cloudinary.com/vantagecircle/image/upload/w_248,h_497/VantageFit/NewWebsite/Contests_Chllngs_Weekly_Step_Callenges.png" alt = "Corporate wellness" className = "img-responsive lozad" loading = "lazy" width="248" height="497"/>
                        </div>
                    </div>
                </div>
                <div className="row innerSpace">
                    <div className="col-lg-3 col-md-12 col-xs-12 col-sm-12 caseFilter">
                    <div className="useCasesBoxes distancebased featuresSpriteM" attr = "distancebased">Distance-Based Contests</div>
                  </div>
                </div>
                <div className="col-lg-12 usecaseDesc" id = "distancebased">
                    <div className="onlineBox  row column-change  d-flex align_items_center mt_25">
                        <div className="col-lg-7 col-md-7 col-xs-12 col-sm-12 ">
                            Create exciting distance-based challenges and let your employees progress one mile at a time.
                        </div>
                        <div className="col-lg-5 col-md-5 col-xs-12 col-sm-12 ">
                            <img src = "https://res.cloudinary.com/vantagecircle/image/upload/w_248,h_497/VantageFit/NewWebsite/Distance_based_competition.png" alt = "corporate wellness program" className = "img-responsive lozad " loading = "lazy"  width="248" height="497"/>
                        </div>
                    </div>
                </div>
                <div className="row innerSpace">
                    <div className="col-lg-3 col-md-12 col-xs-12 col-sm-12 caseFilter">
                    <div className="useCasesBoxes featuresSpriteM wlakathonS " attr = "Walkathon">Walkathon</div>
                  </div>
                </div>
                <div className="col-lg-12 usecaseDesc" id = "Walkathon">
                    <div className="onlineBox  row column-change   d-flex align_items_center mt_25">
                        <div className="col-lg-7 col-md-7 col-xs-12 col-sm-12 ">
                           Motivate employees to take a definite number of daily steps for mitigating the ill-effects of a sedentary lifestyle.
                        </div>
                        <div className="col-lg-5 col-md-5 col-xs-12 col-sm-12 ">
                            <img src = "https://res.cloudinary.com/vantagecircle/image/upload/w_248,h_497/VantageFit/NewWebsite/walkathon.png" alt = "employee wellness" className = "img-responsive lozad" loading = "lazy"  width="248" height="497" />
                        </div>
                    </div>
                </div>
                 <div className="row innerSpace">
                   <div className="col-lg-3 col-md-12 col-xs-12 col-sm-12 caseFilter">
                    <div className="useCasesBoxes healthcampaignS featuresSpriteM" attr = "healthcampaign">Health Campaigns</div>
                  </div>
                </div>
                <div className="col-lg-12  usecaseDesc" id = "healthcampaign">
                    <div className="onlineBox  row column-change  d-flex align_items_center mt_25">
                        <div className="col-lg-7 col-md-7 col-xs-12 col-sm-12 ">
                            Run automated health campaigns as per your desired timeline to streamline your organization's wellness initiatives seamlessly.
                        </div>
                        <div className="col-lg-5 col-md-5 col-xs-12 col-sm-12 ">
                            <img src = "https://res.cloudinary.com/vantagecircle/image/upload/w_248,h_497/VantageFit/NewWebsite/Contests_Chllngs_Health_Campaign.png" alt = "Employee health" className = "max-w lozad" loading = "lazy"  width="248" height="497"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Lazyload offset={100}>
        <section className="sectionSpacing ">
            <div className="container customCampaignContainer">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                        <div className="mainHeadingN text-center">Benefits</div>
                    </div>
                </div>
                <div className="row innerSpace  d-flex align-items-center column-change">
                        <div className = "col-lg-6 col-md-6 col-xs-12 col-sm-6 featuresNbenefits">
                            <div className="onlineBox mt-3">
                                <span className="checkmark"></span>Craft your health and wellness challenges for encouraging fitness.
                            </div>
                            <div className="onlineBox mt-3">
                                <span className="checkmark"></span>Give your employees the best workplace experience with engaging challenges.
                            </div>
                            <div className="onlineBox mt-3">
                                <span className="checkmark"></span>Nurture and sustain a culture of wellness within the organization.
                            </div>
                            <div className="onlineBox mt-3">
                                <span className="checkmark"></span>Host contest of everyone in your organization irrespective of their location.
                            </div>
                        </div>
                        <div className = "col-lg-6 col-md-6 col-xs-12 col-sm-6">
                            <img src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/Benefitd_Contests.png" alt="Step challenge" className="img-responsive lozad"  loading = "lazy" width="530" height="425"/>
                        </div>
                </div>
            </div>
        </section>
        </Lazyload>
        <Lazyload offset={100}>
         <section className="sectionSpacing featuresDetailsShape">
            <div className="container customCampaignContainer">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center">
                        <div className="colorwhite mainHeadingN">Schedule a Vantage Fit Demo</div>
                        <p className="colorwhite">How Corporate Wellness Program can Help Your Organisation</p>
                        <div className="mtb25 cta_center margb"><a href="https://www.vantagefit.io/request-demo/" className="vfitwhitecta ">Schedule a Demo</a></div>
                    </div>
                </div>
            </div>
        </section>
        </Lazyload>
        
        </>
    );
}

export default ContestandChallenges;



